export default [{
  path: '/painel-contratos',
  name: 'painel-contratos',
  component: () => import('@/app-modulo/comercial/contrato/PainelContrato.vue'),
  meta: {
    resource: 'painelproposta',
    action: 'read',
    navActiveLink: 'painel-contratos',
    pageTitle: 'Painel de Contratos',
    breadcrumb: [],
  },
}]
